<template>
  <b-container>
    <h5>Vehicles</h5>
    <div v-if="isLoading" class="text-center my-2">
      <b-spinner variant="yellow" />
    </div>
    <b-table
      v-else
      show-empty
      bordered
      small
      stacked="md"
      head-variant="light"
      :items="vehiclesFromLoad"
      :fields="fields"
    >
      <template v-slot:cell(agent)="{ item }">
        <div v-if="item.user != null">
          {{ item.user.first_name }} {{ item.user.last_name }}
        </div>
      </template>
      <template v-slot:cell(vehicle_has_notes)="{ item }">
        <div v-if="item.vehicle_has_notes && item.vehicle_has_notes.length > 0">
          {{ item.vehicle_has_notes[0].description }}
        </div>
      </template>
      <template v-slot:cell(cluster)="{ item }">
        <div class="text-center">
          <ClusterContextMenu :vehicle="item" :refreshData="() => {}">
            <font-awesome-icon
              class="icon-color cursor-pointer"
              :icon="['far', 'gauge-simple']"
              size="xl"
              :style="{
                color: getClusterVariant(item.vehicle_flags.cluster),
              }"
              @click="openVehicleModal(item, 'cluster-modal', { module: 'cluster', action: 'read' })"
            />
          </ClusterContextMenu>
          <span v-if="item.vehicle_flags.clusterDays">
            {{ item.vehicle_flags.clusterDays }} d
          </span>
        </div>
      </template>
      <template v-slot:cell(actions)="{ item }">
        <div class="text-center">
          <b-icon
            icon="pencil-square"
            font-scale="1.5"
            :variant="item.vehicle_has_notes && item.vehicle_has_notes.length > 0 ? 'yellow' : 'grey'"
            @click="openVehicleModal(item, 'notes-modal', { module: 'notes', action: 'read' })"
          />
        </div>
      </template>
    </b-table>
    <ClusterModal />
    <NotesModal />
  </b-container>
</template>
<script>
import axios from "@/plugins/axios.js";
import { superAdminMixin } from "../mixins";
import ClusterContextMenu from "../components/cluster/ClusterContextMenu.vue";
import ClusterModal from "../components/cluster/ClusterModal.vue";
import NotesModal from "../components/notes/NotesModal.vue";
export default {
  name: "ExportLoadVehiclesTable",
  components: {
    ClusterContextMenu,
    ClusterModal,
    NotesModal,
  },
  props: {
    exportLoadId: {
      type: Number,
      required: true,
    },
  },
  mixins: [superAdminMixin],
  data() {
    return {
      vehiclesFromLoad: [],
      isLoading: false,
      fields: [
        { key: "stock_number", label: "Stock number" },
        { key: "vin_number.vin_number", label: "VIN number" },
        { key: "year", label: "Year" },
        { key: "make", label: "Make" },
        { key: "model", label: "Model" },
        { key: "color", label: "Color" },
        { key: "trim", label: "Trim" },
        { key: "agent", label: "Agent" },
        { key: "cluster", label: "Cluster" },
        { key: "vehicle_has_notes", label: "Note" },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  mounted() {
    this.fetchVehicles();
  },
  methods: {
    openVehicleModal(item, modal, permission) {
      this.openModal(JSON.parse(JSON.stringify(item)), modal, permission);
    },
    normalizeVehicle(v) {
      return {
        ...v,
        stockNumber: v.stock_number,
        vehicleFlags: v.vehicle_flags,
        vehicleInformation: v.vehicle_information,
        vehicleHasNotes: v.vehicle_has_notes,
        vinNumber: v.vin_number
          ? { ...v.vin_number, vinNumber: v.vin_number.vin_number }
          : null,
      };
    },
    fetchVehicles() {
      this.isLoading = true;
      axios
        .get("exportLoad/findVehiclesByLoad", { params: { id: this.exportLoadId } })
        .then((response) => {
          this.vehiclesFromLoad = response.map(this.normalizeVehicle);
        })
        .catch(() => {
          this.$root.$bvToast.toast("Could not load vehicles", {
            title: "Error",
            variant: "warning",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style scoped lang="scss"></style>
